import React, { useState } from 'react';
import { MsComboBox } from '../MsComboBox';
import { type Tag, useTagSuggestions } from '../../hooks/useTags';

interface Props {
  projectId: string;
  selected: Tag[];
  onChange: (tags: Tag[]) => void;
  placeholder?: string;
  testId?: string;
}

export function TagTypeahead({ projectId, selected, onChange, placeholder, testId }: Props) {
  const [query, setQuery] = useState('');
  const { data: suggestions = [] } = useTagSuggestions(projectId, query);

  return (
    <MsComboBox<Tag>
      selected={selected}
      suggestions={suggestions}
      onChange={onChange}
      onQueryChange={setQuery}
      getKey={t => t.id}
      getLabel={t => t.name}
      getColor={t => t.color}
      icon="fa-circle"
      placeholder={placeholder}
      testId={testId}
    />
  );
}
